import { BaseDto } from '@/shared/dtos/base-dto';

export class dietaDto extends BaseDto {
    public paciente !: number;
    public fecha!: Date;
    public visible_paciente !: boolean;
    public id_nutricionista !: number;
}